import { useMemo } from "react";

import type { SiteControllerSettingTllFormModel } from "@/components/features/settings/site-controller/model/tl-lincoln/type";

import type { FormOptionType } from "@/components/ui/form/_types/type";

type Props = {
	rooms: SiteControllerSettingTllFormModel["ViewModel"]["tll"]["rooms"]; //

	defaultPlan: SiteControllerSettingTllFormModel["ViewModel"]["tll"]["defaultPlan"]; //
	plans: SiteControllerSettingTllFormModel["ViewModel"]["tll"]["plans"]; //
};

export const useTlLincolnPlanMapping = ({
	defaultPlan,
	plans, //
	rooms,
}: Props) => {
	const defaultPlanOptions: FormOptionType[] = useMemo(
		() =>
			plans.value.map((plan) => {
				return {
					id: plan.tllPlanID.value,
					label: plan.planName.value,
					value: plan.tllPlanID.value,
				} satisfies FormOptionType;
			}),
		[plans.value],
	);

	const selectedPlanInfo = useMemo(
		() => plans.value.find((plan) => plan.tllPlanID.value === defaultPlan?.value),
		[defaultPlan?.value, plans.value],
	);

	// 利用可能な部屋
	const availableRoomsText = useMemo(() => {
		if (!selectedPlanInfo) return undefined;

		return selectedPlanInfo.roomStatus.value
			.filter((room) => room.inSale.value)
			.map((room) => rooms.value.find((r) => r.tllRoomID.value === room.tllRoomID.value))
			.map((room) => `「${room?.tllRoomTypeName.value}」`)
			.join(", ");
	}, [rooms.value, selectedPlanInfo]);

	return {
		defaultPlanOptions,

		selectedPlanInfo,
		availableRoomsText,
	};
};
